import React, { PureComponent } from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { message, Button, Input, Select, Upload } from "antd";
import logo from "../../../assets/excelTeml/tenceData.xls";
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import fetchHandler from "@/fetch/fetchHandler";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { lockBind, prefixFile } from "@/fetch/fetchApi";

const FormItem = Form.Item;
var loading = false;
const uploadButton = (
      <div>
        {loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );

// eslint-disable-next-line arrow-parens
@connect(state => state)
class GoodExcelInClass extends PureComponent {
  
  constructor(props) {
    super(props);
    this.state = {
      hidden:true,
      imageUrl:null,
      msg:'',
      internationalization: this.props.intl.messages.stubBindLock,
    };
  }


  formRef = React.createRef();

  render() {
    var userId = window.sessionStorage.getItem("userId");
    var companyId = window.sessionStorage.getItem("companyId");
    const uploadProps = {
      name: "file",
      multiple: false,
      accept: ".xls",
      action:
        `${prefixFile}/mtsV2/save/tenceBatchIn.do?userId=${userId}&companyId=${companyId}`,
      headers: {
        authorization: "authorization-text",
      },
      showUploadList: false,
      // progress:{
      //     type:'line'
      // },
      onChange: (info) => {
        this.setState({
          btnLoading: true,
          msg:'',
        });
        console.log(info)
        if (info.file.response !== undefined && info.file.response === 1) {
          this.setState({
            msg:'',
            btnLoading: false,
          });
          this.state.display = "";
          message.success('导入成功');
          if (this.props.onCancel) {
            this.props.onCancel();
          }
          if (this.props.refreshGrid) {
            this.props.refreshGrid();
          }

        } else if (info.file.response !== undefined && info.file.response.status !== "200") {
          this.setState({
            btnLoading: false,
            msg:info.file.response.message ? info.file.response.message : info.file.response.text
          });
          message.error(info.file.response.message ? info.file.response.message : info.file.response.text);
        }
      },
    };
    return (
      <div>
        <a style={{marginBottom: '20px',display: 'inline-block'}} target='_blank' href={logo}>模板下载</a>
        <Form ref={this.formRef}>
         
        <Upload {...uploadProps}>
              <Button
                type="primary"
                disabled={this.state.btnDisabled}
              loading={this.state.btnLoading}
                style={{ display: this.state.btnDisplay, margin: "0 auto" }}>
                上传并校验
              </Button>
            </Upload>
              <div style={{ margin: "5px 0 0 0", color: 'red' }}>
                <span>{this.state.msg}</span>
              </div>
        </Form>
      </div>
    );
  }
}

const GoodExcelIn = Form.create()(GoodExcelInClass);

export default injectIntl(GoodExcelIn);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/goodExcelIn.js